import { useContext } from 'react'
import SessionContext, { SessionContextT } from 'services/Session/context'

export default (): SessionContextT => useContext(SessionContext)
